import TextField from 'modules/core/components/TextField'
import { useFormContext } from 'modules/core/hooks/useForm'

import { WorkingConditionDisplayItemProps } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'
import { getI18nItemFieldKey } from 'modules/contracts_settings/lib/useWorkConditionItemsCategories'
import { WorkConditionVersionItemsFormData } from 'modules/contracts_settings/pages/WorkingConditionsVersionPage/forms'

const WorkingConditionItemCentsField = ({ name }: WorkingConditionDisplayItemProps) => {
  const form = useFormContext<WorkConditionVersionItemsFormData>()
  const stringValue = form.values.items[name]
  const value = stringValue ? (parseInt(stringValue) / 100).toString() : undefined

  const toCents = (stringNumber: string) => {
    const parsedValue = parseInt(stringNumber)
    return parsedValue ? (parsedValue * 100).toString() : undefined
  }

  return (
    <TextField
      type={'number'}
      label={getI18nItemFieldKey(name, 'label')}
      value={value}
      onChange={(newValue) => form.setFieldValue('items.' + name, toCents(newValue))}
      error={form.touched.items?.[name] ? form.errors.items?.[name] : undefined}
    />
  )
}

export default WorkingConditionItemCentsField
